import React from 'react';
import { CheckCircle2Icon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const rows = [['Ore perse a pianificare ogni lezione da zero', 'Sessioni pronte da adattare al tuo Studio'], ['Esercizi ripetuti sul Mat o Reformer', '150+ esercizi e nuove sequenze'], ['Gruppi misti difficili da gestire', 'Variazioni chiare per ogni livello'], ['Incertezza con esigenze specifiche', 'Protocolli clinici e popolazioni speciali'], ['Entrare in Studio senza un piano', '6 volumi per insegnare con metodo']];
export function FinalCTA() {
  return <section data-cta-block className="border-y-4 border-emerald-400 bg-[#241622] px-5 py-20" data-id="element-38" data-mp="vv1cdq4d0cbt">
      <div className="mx-auto max-w-3xl text-center" data-id="element-39" data-mp="qv5abwf82uyw">
        <h2 className="font-display text-4xl font-bold uppercase leading-none text-white sm:text-6xl" data-id="element-40" data-mp="qxrowg0j6aqm">
          Smetti di improvvisare.{' '}
          <span className="text-emerald-300" data-id="element-41" data-mp="zwv77hrvim42">
            Inizia a insegnare con un sistema.
          </span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl font-medium leading-relaxed text-slate-300" data-id="element-42" data-mp="2c5yavq9tyney">
          Unisciti a oltre 1500 insegnanti di Pilates che pianificano l’intero
          anno in meno di 5 minuti.
        </p>
        <p className="mt-5 text-xs font-bold uppercase tracking-[.18em] text-emerald-200" data-id="element-43" data-mp="2m19i7niwssco">
          Sessioni · Esercizi · Progressioni · Reformer · Matwork · Tutto
          organizzato
        </p>
        <div className="mt-10 overflow-hidden rounded-2xl border border-emerald-300/30 text-left" data-id="element-44" data-mp="2v2zf38vk8jhu">
          <div className="grid grid-cols-2 bg-[#38233c] text-center text-[10px] font-bold uppercase tracking-widest" data-id="element-45" data-mp="3010wzqh92crq">
            <p className="p-4 text-slate-300" data-id="element-46" data-mp="34vexg7arra39">Senza Pilates Pronta</p>
            <p className="border-l border-emerald-300/30 p-4 text-emerald-300" data-id="element-47" data-mp="39rvnj71j3yiz">
              Con Pilates Pronta
            </p>
          </div>
          {rows.map(([without, withSystem]) => <div key={without} className="grid grid-cols-2 border-t border-emerald-300/20 text-xs sm:text-sm" data-id="element-48" data-mp="3iu4y1wwsrrwd">
              <p className="flex gap-2 p-4 font-medium text-slate-300" data-id="element-49" data-mp="1jp4wpxmojdr1">
                <span className="text-rose-400" data-id="element-50" data-mp="1eps6d2wlnojp">×</span>
                {without}
              </p>
              <p className="flex gap-2 border-l border-emerald-300/20 bg-emerald-300/5 p-4 font-semibold text-white" data-id="element-51" data-mp="1sh6oz8mlhnq8">
                <CheckCircle2Icon className="h-4 w-4 shrink-0 text-emerald-300" data-id="element-52" data-mp="1novq893lc7z9" />
                {withSystem}
              </p>
            </div>)}
        </div>
        <div className="my-9" data-id="element-53" data-mp="1xfqcvekr19l8">
          <CountdownTimer dark data-id="element-54" data-mp="1xeos2idxl8qb" />
        </div>
        <div className="rounded-2xl border-2 border-emerald-400 bg-[#38233c] p-7 text-left" data-id="element-55" data-mp="1xhuko7lrqsqs">
          <p className="text-xs font-bold uppercase tracking-widest text-emerald-300" data-id="element-56" data-mp="2bdf02t2agstg">
            Pacchetto completo
          </p>
          <h3 className="mt-2 text-xl font-bold text-white" data-id="element-57" data-mp="h18b8rgh2dio">
            PILATES PRONTA™ — 6 Volumi + 5 Bonus
          </h3>
          <div className="mt-5 flex items-end justify-between" data-id="element-58" data-mp="d0y9jqzpq99m">
            <div data-id="element-59" data-mp="2vye3nk22fuy">
              <p className="text-sm font-bold text-slate-300 line-through" data-id="element-60" data-mp="2vg8w1ff0raw">
                €106
              </p>
              <p className="font-display text-6xl font-bold leading-none text-white" data-id="element-61" data-mp="6wi8wkh5p7dx">
                €19
              </p>
            </div>
            <p className="bg-emerald-400 px-3 py-2 text-xs font-bold uppercase text-[#241322]" data-id="element-62" data-mp="3p9gcd1d5qicu">
              Risparmi €87
            </p>
          </div>
        </div>
        <a href="https://pilates-pronta.impultienda.ar/checkout" className="cta-button mt-8 block w-full rounded-2xl px-5 py-5 text-lg font-bold sm:text-xl" data-id="element-63" data-mp="3fclhcsg3f03b">
          SCARICA IL MEGAPACK COMPLETO A €19
        </a>
        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-slate-300" data-id="element-64" data-mp="36ej7roiamz4f">
          <span className="flex gap-1" data-id="element-65" data-mp="3bdvvsckwic8l">
            <LockKeyholeIcon className="h-4 w-4 text-emerald-300" data-id="element-66" data-mp="14ks86rpk5h1c" />
            Pagamento sicuro
          </span>
          <span className="flex gap-1" data-id="element-67" data-mp="19jdbx140qiuj">
            <ZapIcon className="h-4 w-4 text-emerald-300" data-id="element-68" data-mp="19ibzas7ctoap" />
            Accesso immediato
          </span>
          <span className="flex gap-1" data-id="element-69" data-mp="35l6zyi1lhtdz">
            <ShieldCheckIcon className="h-4 w-4 text-emerald-300" data-id="element-70" data-mp="30o6ry1l6qgk8" />
            Garanzia 7 giorni
          </span>
        </div>
      </div>
    </section>;
}